import React from 'react';
export function ArrowUpIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 11.394l-7.06-7.082a1 1 0 00-1.414 0L4.241 11.37a1 1 0 001.412 1.416l5.372-5.356-.018 11.586a1 1 0 102 0l.018-11.587 5.356 5.373a1 1 0 001.419-1.41z"
  }));
}